import React from 'react';

import { connect } from 'react-redux';
import { mudarUser, logout } from '../actions/AppActions';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import { CandidateValidationNotice } from './CandidateUi';

import { Modal, Button } from 'react-bootstrap'

class RequestUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_screen: false,
            show_video: false,
            show_solicitar: true,
            show_aceitar: false,
            stream: null,
            redirect: false,
            path: '/sala',
            processos: [],
            candidato_id: '',
            loading: false,
            acao: '',
            msgErro: '',
            message:''
        }
    }
    


    

    






    render() {
        const t = getLanguageTexts(getSelectedLanguage());
      
        return (
            <>
               


                <Modal
                    show={this.props.show_pause_modal}
                    onHide={() => this.props.setModal(false)}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <span style={{color:'black'}}>{t.request_pause_title}</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.msgErro != '' && <div>
                            <CandidateValidationNotice tone="danger">{this.state.msgErro}</CandidateValidationNotice>
                            <br />

                        </div>}
                        {this.props.user.id!=undefined && <div className="form-group row mb-0">
                            <div className="col-sm-12">
                                <p style={{color:'black',marginBottom:5,fontSize:16}}><b style={{marginRight: "2px"}}>{t.name_label}: </b>{this.props.user.name}</p>
                            </div>
                        </div>}
                        <p style={{color:'black',marginBottom:5,fontSize:16}}>{t.pause_request_explanation}</p>
                        <p style={{color:'black',marginBottom:5,fontSize:16}}>{t.pause_keep_camera}</p>
                        <p style={{color:'black',marginBottom:5,fontSize:16}}>{t.pause_return_before_end}</p>
                       
                        <div className="form-group row">
        
                            <label className="col-sm-12 col-form-label" style={{color:'black',fontSize:16}}>{t.pause_reason_label} <span style={{color: "red", fontWeight: "700"}}>*</span></label>
                            <div className="col-sm-12">
                                <textarea className="form-control" value={this.state.message} placeholder={t.report_action_placeholder} type="text" onChange={(e) =>{
                                    if(e.target.value.length<=200){
                                        this.setState({ message: e.target.value })
                                    }
                                }} />
                                <p style={{ marginBottom: 0 }}>{t.character_count}: {this.state.message.length + '/200'}</p>

                            </div>
                        </div>
                    </Modal.Body>
                    {this.state.loading == false && <Modal.Footer>
                        <Button variant="secondary" className="btn-lg" onClick={() => this.props.setModal(false)}>{t.close}</Button>
                        <Button className="btn-lg" onClick={() => {
                            if(this.state.message.length<5){
                                this.setState({msgErro:t.pause_reason_min_error});
                            }
                            else{
                                this.props.sendRequest(this.state.message)
                                this.setState({message:'',msgErro:''});
                                this.props.setModal(false);
                            }
                        }}>{t.send}</Button>

                    </Modal.Footer>}
                    {this.state.loading == true && <Modal.Footer><div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                        <div className="spinner-border text-primary" role="status"  >
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div></div></Modal.Footer>}
                </Modal>

            </>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
    }
);

export default connect(mapsStateToProps, { mudarUser, logout })(RequestUser);
